import { useState } from 'react';
import { TextComponent } from './TextComponent';
import CircularProgress from './CircularProgress';

interface CustomInputProps {
  label?: string;
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  obscureText?: boolean;
  small?: boolean;
  full?: boolean;
  required?: boolean;
  hintText?: string;
  align?: 'left' | 'center' | 'right';
  className?: string;
  readOnly?: boolean; 
  boxLabel?: string;
  [x: string]: any;
  isLoading?: boolean;
  endAdornment?: React.ReactNode;
}

export const CustomInput = ({
  label,
  value,
  onChange,
  onBlur,
  mask,
  hintText,
  obscureText = false,
  small = false,
  full = false,
  required = false,
  align = 'left',
  className = '',
  boxLabel,
  isLoading = false,
  endAdornment,
  readOnly = false,
  ...props
}: CustomInputProps) => {
  const [isObscured, setIsObscured] = useState(obscureText);

  const toggleObscureText = () => {
    setIsObscured(!isObscured);
  };

  let alignClass = '';

  switch (align) {
    case 'left':
      alignClass = 'text-left';
      break;
    case 'center':
      alignClass = 'text-center';
      break;
    case 'right':
      alignClass = 'text-right';
      break;
    default:
      alignClass = 'text-left';
  }

  return (
    <div className={`flex w-full flex-col ${className} ${small && !full ? '' : 'md:w-full'}`} {...props}>
      {
        label ?
          <TextComponent variant='h6'>
            {label}
            {required && <span className="text-red-500">*</span>}
          </TextComponent>
          : <></>
      }
      <div className="flex items-center">
        {boxLabel && (
          <div className={`${small ? 'py-2' : 'py-4 '}  px-4 border-t border-l border-b rounded-tl-lg rounded-bl-lg text-gray-700`}>
            {boxLabel}
          </div>
        )}
        <div className="relative flex-grow">
          {
            (value ? (
              <input
                type={isObscured ? 'password' : 'text'}
                value={value ?? ''}
                placeholder={hintText}
                onChange={onChange}
                onBlur={onBlur}
                readOnly={readOnly}
                className={`w-full ${small ? 'py-2' : 'py-4'} ${small && !full ? 'md:w-130' : 'md:w-full'} border ${boxLabel ? ' rounded-tr-lg rounded-br-lg' : 'rounded-lg'} ${alignClass} px-2 ${value ? 'font-bold text-blue' : 'font-normal'
                  }`}
                {...props}
              />) : (
              <input
                type={isObscured ? 'password' : 'text'}
                onChange={onChange}
                placeholder={hintText}
                onBlur={onBlur}
                className={`w-full ${small ? 'py-2' : 'py-4'} ${small && !full ? 'md:w-130' : 'md:w-full'} border ${boxLabel ? ' rounded-tr-lg rounded-br-lg' : 'rounded-lg'} ${alignClass} px-2 ${value ? 'font-bold text-blue' : 'font-normal'
                  }`}
                {...props}
              />)
            )}

          {endAdornment && (
            <div className="absolute inset-y-0 right-0 flex items-center pr-3">
              {endAdornment}
            </div>
          )}

          {obscureText && (
            <button
              type="button"
              onClick={toggleObscureText}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
            >
              {isObscured ? '👁️' : '👁️‍🗨️'}
            </button>
          )}

          {isLoading && (
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5">
              <CircularProgress size={24} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};